export default {"src":"/_next/static/media/heart-black.0ccbf08b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};